/*global google */

const options = {
  types: ["address"],
  componentRestrictions: {
    country: "us"
  }
};

const fields = ["address_components"];

// See: https://developers.google.com/maps/documentation/javascript/geocoding#GeocodingAddressTypes
const fieldMap = {
  addrLine1: ["street_number", "route"],
  addrLine2: null,
  city: "locality",
  state: "administrative_area_level_1",
  zip: "postal_code",
  country: "country"
};

const createAddress = ({ address_components }) => {
  const findField = type =>
    address_components.find(({ types }) => types.includes(type));

  const fields = {};
  for (const [key, value] of Object.entries(fieldMap)) {
    if (!value) continue;

    const valueArry = Array.isArray(value) ? value : [value];

    fields[key] = valueArry
      .map(value => findField(value))
      // some fields might not always exist in all addresses, such as a street_number
      .filter(field => field)
      .map(field => field.short_name)
      // should not filter out anything since we've filtered out nonexistent fields above, but just in case
      .filter(val => val)
      .join(" ");
  }
  return fields;
};

export const autocompleteAddress = (el, callback) => {
  const autocomplete = new google.maps.places.Autocomplete(el, options);
  autocomplete.setFields(fields);
  const listener = autocomplete.addListener("place_changed", () => {
    const place = autocomplete.getPlace();
    const address = createAddress(place);
    callback(address);
  });

  return {
    destroy() {
      google.maps.event.removeListener(listener);
    }
  };
};
